import { render } from "./AppSubmenu.vue?vue&type=template&id=0aec1bbd&scoped=true"
import script from "./AppSubmenu.vue?vue&type=script&lang=js"
export * from "./AppSubmenu.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0aec1bbd"

export default script